import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.fund.list.exit');
import { OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-lpsysadmin-fund-list-exit',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.fund.list.exit/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminFundListExitComponent implements OnInit {
    @Input() view: any;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.view == "admin") await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        else await this.service.auth.allow(true, "/landing");
        try {
            await this.loadGpSettings();
            await this.loadDashboard();
        } catch (e) {
            console.error('GP settings/dashboard load error:', e);
        }
        await this.load();
    }

    public dashboard: any = [];
    public gpList: string[] = [];
    public selectedGps: string[] = [];
    public showGpSettings: boolean = false;

    public async toggleGpSettings() {
        this.showGpSettings = !this.showGpSettings;
        this.cdr.detectChanges();
    }

    public async loadGpSettings() {
        const gpRes = await wiz.call("gp_list");
        if (gpRes.code == 200) {
            this.gpList = gpRes.data.gp_list;
        }
        const settingsRes = await wiz.call("gp_settings_load");
        if (settingsRes.code == 200 && settingsRes.data.settings?.selected_gps) {
            this.selectedGps = settingsRes.data.settings.selected_gps;
        }
        this.cdr.detectChanges();
    }

    public isGpSelected(gp: string): boolean {
        return this.selectedGps.includes(gp);
    }

    public async toggleGp(gp: string) {
        const idx = this.selectedGps.indexOf(gp);
        if (idx >= 0) {
            this.selectedGps.splice(idx, 1);
        } else {
            this.selectedGps.push(gp);
        }
        this.cdr.detectChanges();
    }

    public async saveGpSettings() {
        await wiz.call("gp_settings_save", { selected_gps: JSON.stringify(this.selectedGps) });
        this.showGpSettings = false;
        await this.loadDashboard();
        this.cdr.detectChanges();
    }

    public async loadDashboard() {
        const { code, data } = await wiz.call("dashboard");
        if (code == 200) {
            this.dashboard = data.dashboard;
        }
        this.cdr.detectChanges();
    }

    public loading: boolean = false;
    public list: any = [];
    public search: any = {
        text: "",
        page: 1,
        dump: 200
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public sortField: string = '';
    public sortOrder: string = 'ASC';

    public gradeOrder: any = { 'S': 1, 'A': 2, 'B': 3, 'C': 4, 'D': 5 };
    public gradeStyle: any = {
        'S': 'bg-blue-100 text-blue-800',
        'A': 'bg-emerald-100 text-emerald-800',
        'B': 'bg-yellow-100 text-yellow-800',
        'C': 'bg-orange-100 text-orange-800',
        'D': 'bg-red-100 text-red-800'
    };

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortField = field;
            const textFields = ['name', 'gp', 'company', 'type', 'investment_resource', 'category', 'investment_status', 'latest_grade'];
            this.sortOrder = textFields.includes(field) ? 'ASC' : 'DESC';
        }

        const dir = this.sortOrder === 'ASC' ? 1 : -1;
        this.list.sort((a, b) => {
            let va: any, vb: any;
            if (field === 'gp') {
                va = a.gp_string || ''; vb = b.gp_string || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'registered_date') {
                va = a.registered_date || ''; vb = b.registered_date || '';
            } else if (field === 'name') {
                va = a.name || ''; vb = b.name || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'type') {
                va = a.type || ''; vb = b.type || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'investment_resource') {
                va = a.investment_resource || ''; vb = b.investment_resource || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'category') {
                va = a.category || ''; vb = b.category || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'investment_status') {
                va = a.investment_status || ''; vb = b.investment_status || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'total_amount') {
                va = a.total_amount || 0; vb = b.total_amount || 0;
                return (va - vb) * dir;
            } else if (field === 'company') {
                va = (a.investment && a.investment[0]?.company_name) || '';
                vb = (b.investment && b.investment[0]?.company_name) || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'latest_grade') {
                va = (a.investment && a.investment[0]?.latest_grade) || '';
                vb = (b.investment && b.investment[0]?.latest_grade) || '';
                const oa = this.gradeOrder[va] || 99;
                const ob = this.gradeOrder[vb] || 99;
                return (oa - ob) * dir;
            } else if (field === 'investment_date') {
                va = (a.investment && a.investment[0]?.investment_date) || '';
                vb = (b.investment && b.investment[0]?.investment_date) || '';
            } else if (field === 'sell_date') {
                const getLatestSell = (item) => {
                    let latest = '';
                    for (let s = 1; s <= 5; s++) {
                        const d = item.investment?.[0]?.[`sell${s}_data`];
                        const dt = d?.date || '';
                        if (dt > latest) latest = dt;
                    }
                    return latest;
                };
                va = getLatestSell(a); vb = getLatestSell(b);
            } else if (field === 'invest_sum') {
                const sumInv = (item) => {
                    if (!item.investment || item.investment.length === 0) return 0;
                    let total = 0;
                    for (const inv of item.investment) total += this.sumInvestment(inv);
                    return total;
                };
                va = sumInv(a); vb = sumInv(b);
                return (va - vb) * dir;
            } else if (field === 'fund_sum') {
                const fundSum = (item) => {
                    if (!item.investment || item.investment.length === 0) return 0;
                    let total = 0;
                    for (const inv of item.investment) total += this.sumInvestment(inv);
                    return total;
                };
                va = fundSum(a); vb = fundSum(b);
                return (va - vb) * dir;
            } else if (field === 'invest_total') {
                const investTotal = (item) => {
                    if (!item.investment || item.investment.length === 0) return 0;
                    let total = 0;
                    for (const inv of item.investment) total += (inv.investment_amount ? inv.investment_amount * 1 : 0);
                    return total;
                };
                va = investTotal(a); vb = investTotal(b);
                return (va - vb) * dir;
            } else {
                return 0;
            }
            return (va > vb ? 1 : va < vb ? -1 : 0) * dir;
        });
        this.cdr.detectChanges();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return ' ↕';
        return this.sortOrder === 'ASC' ? ' ▲' : ' ▼';
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        this.cdr.detectChanges();

        const { code, data } = await wiz.call("search", this.search);

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        this.cdr.detectChanges();
    }

    public iterItems(item: any) {
        if (item.investment.length == 0) {
            let row: any = JSON.parse(JSON.stringify(item));
            row.investment = {};
            row._rowspan = 1;
            row.invest_total = 0;
            return [row];
        }

        let rows: any = [];
        let sum = 0;
        let investSum = 0;
        for (let i = 0; i < item.investment.length; i++) {
            let row: any = JSON.parse(JSON.stringify(item));
            if (i == 0) row._rowspan = item.investment.length;
            row.investment = item.investment[i];
            sum += this.sumInvestment(row.investment);
            investSum += (row.investment.investment_amount ? row.investment.investment_amount * 1 : 0);
            rows.push(row);
        }

        rows[0].investment_total = sum;
        rows[0].invest_total = investSum;

        return rows;
    }

    public formatter: any = {
        date: (date) => {
            if (!date) return "-";
            date = date.date
            if (!date) return "-";
            return moment(date).format("YYYY-MM-DD");
        }
    }

    public sumInvestment(item) {
        // Use extra.sells if available (dynamic entries)
        if (item.extra?.sells && item.extra.sells.length > 0) {
            let amount = 0;
            for (let sell of item.extra.sells) {
                if (sell && sell.amount) amount += sell.amount * 1;
            }
            return amount;
        }
        // Fallback: sell1-5 columns
        let amount = item.sell1_amount ? item.sell1_amount * 1 : 0;
        if (item.sell2_amount > 0) amount += item.sell2_amount * 1;
        if (item.sell3_amount > 0) amount += item.sell3_amount * 1;
        if (item.sell4_amount > 0) amount += item.sell4_amount * 1;
        if (item.sell5_amount > 0) amount += item.sell5_amount * 1;
        return amount;
    }

    public exporting: boolean = false;

    public async exportExcel() {
        if (this.exporting) return;
        this.exporting = true;
        this.cdr.detectChanges();

        try {
            const response = await fetch('/wiz/api/portal.lpsysadmin.fund.list.exit/export_excel', {
                method: 'POST',
                body: new FormData(),
                credentials: 'same-origin'
            });
            if (!response.ok) throw new Error('Server error');
            const blob = await response.blob();
            if (blob.size === 0) throw new Error('Empty response');
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            a.download = `해산청산조합_${today}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            this.service.alert.error('엑셀 다운로드 실패');
        }

        this.exporting = false;
        this.cdr.detectChanges();
    }

}

export default PortalLpsysadminFundListExitComponent;